import Dropdown from 'react-bootstrap/Dropdown';

const StoreSelector = ({ store, availableStores, setStore, className }) => {
    return (
            <Dropdown
                className={className}
            >
                <Dropdown.Toggle 
                    variant="primary" 
                    id="dropdown-store"
                >
                    <span>
                        BODEGA
                    </span>
                    <span className="ms-4 fw-bold">
                        {store}
                    </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {availableStores.map((item, index) => (
                        <Dropdown.Item 
                            key={"store-" + index}
                            onClick={() => setStore(item)}
                        >
                            {item}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
    );
}

export default StoreSelector;